/**
 * Whether `key` differs between two field snapshots. Values are compared by
 * JSON serialization rather than `===` so array/object fields (tools, parts,
 * documents, ...) count as changed only when their contents actually differ,
 * not merely because a new render produced a new reference.
 *
 * Shared by the guide and wiki editors' dirty/conflict checks (guide_patch.ts,
 * WikiEditPage.tsx) so the definition of "changed" can't drift between them.
 */
export function fieldChanged<Fields, Key extends keyof Fields>(
   current: Fields,
   baseline: Fields,
   key: Key
): boolean {
   return JSON.stringify(current[key]) !== JSON.stringify(baseline[key]);
}
